<template>
  <div class="product_centers">
    <nav-header :navs="4" :navsitems="a" />
    <div class="product_type_centers">
      <div class="in-banner">
        <div class="swiper-centers">
          <swiper class="swiper-container" :options="swiperOption">
            <swiper-slide v-for="(item, index) in slideList" :key="index">
              <img :src="item.image" alt="" width="100%" height="auto" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
      <div class="product_tit">产品中心</div>
      <div class="product_type_list" style="display: none">

        <div class="list-item" @click="goPages('33')">
          <div
            style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/F1.jpg" width="80%" height="auto" />
          </div>
          <div><b>智能集成电力电容补偿装置</b></div>
        </div>
        <div class="list-item" @click="goPages('35')">
          <div
            style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >0
            <img src="../../public/imgs/A.jpg" width="80%" height="auto" />
          </div>
          <div><b>智能抑谐式集成电力电容补偿装置</b></div>
        </div>
        <div class="list-item" @click="goPages('39')">
          <div
              style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/C2.jpg" width="80%" height="auto" />
          </div>
          <div><b>综合测控装置</b></div>
        </div>
        <div class="list-item" @click="goPages('41')">
          <div
            style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/C1.jpg" width="80%" height="auto" />
          </div>
          <div><b>电能质量治理装置</b></div>
        </div>

        <div class="list-item" @click="goPages('43')">
          <div
            style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/J1.jpg" width="80%" height="auto" />
          </div>
          <div><b>传统式无功补偿器件</b></div>
        </div>
        <div class="list-item" @click="goPages('49')">
          <div
              style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/D9.jpg" width="80%" height="auto" />
          </div>
          <div><b>智能仪表</b></div>
        </div>
        <div class="list-item" @click="goPages('122')">
          <div
            style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/Z1.jpg" width="80%" height="auto" />
          </div>
          <div><b>物联网产品</b></div>
        </div>
      </div>
      <div class="sec_fadeInUp">
        <el-row>
          <el-col :xs="{span:24}" :sm="{span:6}" :lg="{span:6}">
            <div class="pro_box" @click="goPages('33')">
              <div class="pro_con_img">
                <img src="../assets/img/dy.png" alt="智能集成电力电容补偿装置">
                <p class="cp_sta_title">智能集成电力电容补偿装置</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:6}" :lg="{span:6}">
            <div class="pro_box" @click="goPages('35')">
              <div class="pro_con_img">
                <img src="../assets/img/jcdldr.png" alt="智能抑谐式集成电力电容补偿装置">
                <p class="cp_sta_title">智能抑谐式集成电力电容补偿装置</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:6}" :lg="{span:6}">
            <div class="pro_box" @click="goPages('39')">
              <div class="pro_con_img">
                <img src="../assets/img/zhckzz.png" alt="综合测控显示装置"/>
                <p class="cp_sta_title">综合测控显示装置</p>

              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:6}" :lg="{span:6}">
            <div class="pro_box" @click="goPages('41')">
              <div class="pro_con_img">
                <img src="../assets/img/dnzlzz.png" alt="电能质量治理装置">
                <p class="cp_sta_title">电能质量治理装置</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:6}" :lg="{span:6}">
            <div class="pro_box" @click="goPages('43')">
              <div class="pro_con_img">
                <img src="../assets/img/ctswugcqi.png" alt="传统式无功补偿器件">
                <p class="cp_sta_title">传统式无功补偿器件</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:6}" :lg="{span:6}">
            <div class="pro_box" @click="goPages('49')">
              <div class="pro_con_img">
                <img src="../assets/img/yb4.png" alt="智能电力仪表">
                <p class="cp_sta_title">智能电力仪表</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:6}" :lg="{span:6}">
            <div class="pro_box" @click="goPages('122')">
              <div class="pro_con_img">
                <img src="../assets/img/wlwcp4.png" alt="物联网产品">
                <p class="cp_sta_title" style="bottom: 20%">物联网产品</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <nav-footer />
  </div>
</template>
  <script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import NavHeader from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
export default {
  name: "product",
  components: {
    NavHeader,
    NavFooter,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      a: "",
      product: {}, //商品信息
      swiperOption: {
        autoplay: true,
        loop: true,
        speed: 2000,
        cubeEffect: {
          shadowOffset: 100,
          shadowScale: 0.6,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },

      image: "",
      slideList: [
        {
          image: "http://www.jiukaist.com/uploads/20240119/371734531536edb6e8fb43e96f31b776.png",
        },
        {
          image: "http://www.jiukaist.com/uploads/20240119/288cfb6602f3319998368f7fcbb93b78.png",
        },
      ],
    };
  },
  created() {
    localStorage.clear();

  },
  mounted() {
    //this.getProductInfo();
  },
  methods: {
    goPages(val) {
      let self = this;
      self.$router.push("/product_type_list/" + val);
    },
    // 获取商品信息
    getProductInfo() {
      let id = this.$route.params.id;
      this.$api.mall.getProductInfo(id).then((res) => {
        this.product = res;
      });
    },
  },
};
</script>
  <style lang="scss">
.product_centers {
  width: 100%;
  min-width: 1350px;
  overflow: hidden;
  background: #f5f5f5;
  .swiper-button-next:after,
  .swiper-container-rtl .swiper-button-prev:after {
    content: "" !important;
  }
  .swiper-button-prev:after,
  .swiper-container-rtl .swiper-button-next:after {
    content: "" !important;
  }
  .swiper-button-next {
    background: url(../../public/imgs/right-c.png) no-repeat center;
    opacity: 0.6;
    width: 42px;
    height: 42px;
    background-size: 42px;
  }
  .swiper-button-prev {
    background: url(../../public/imgs/left-c.png) no-repeat center;
    width: 42px;
    opacity: 0.6;
    height: 42px;
    background-size: 42px;
  }
  .product_tit{
    width: 100%;
    font-weight: 600;
    font-size: 24px;
    overflow: hidden;
    line-height: 1.8;
    text-align: center;
    margin: 18px auto;
  }
  .in-banner {
    width: 100%;
    overflow: hidden;
    margin: 75px auto auto auto;
  }
  .product_type_list {
    width: 1200px;
    padding: 0px;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0px auto;
    padding: 0.82rem 0 2rem;
    .list-item {
      cursor: pointer;
      width: 280px;
      margin-left: 18px;
      margin-top: 18px;
      line-height: 1.5;
      font-size: 16px;
      float: left;
      padding: 10px;
      background: #fff;
      box-sizing: border-box;
      text-align: center;
      img {
        margin: 0px auto;
      }
    }
  }
  .product_type_centers {
    width: 100%;
    padding: 0px;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0px auto;
  }
  .sec_fadeInUp{
    min-width: 1200px;
    padding: 0px;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0px auto;
    padding: 0.82rem 0 2rem;
    .pro_box{
      background: #e3e3e3;
      //margin: 0 20px 20px 0;
      //width: 322px;
      margin: 10px;
      margin-top: 0;
      height: 250px;
      cursor: pointer;
    }
    .pro_box:last-child {
      margin-right: 0!important;
    }
    .secon{
      opacity: 1!important;
    }
    .pro_con_img {
      position: relative;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      img {
        width: 100%;
        height: 250px;
        object-fit: contain;
      }
      .cp_sta_title{
        position: absolute;
        font-size: 16px;
        color: #333;
        font-weight: 600;
        bottom: 30px;
        width: 100%;
        text-align: center;
      }
    }
    .pro_con_txt {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      background: rgba(50,50,50,0.8);
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
    .pro_con_txt h3 {
      font-size: 20px;
      width: auto;
      color: #fff;
      margin-bottom: 15px;
    }
    .public_btn{
      width: 80px;
      height: 45px;
      line-height: 45px;
      transition: all 0.5s;
      background-color: #1d8d3b;
      color: #fff;
      letter-spacing: 1px;
      border-radius: 5px;
      font-weight: bold;
      text-align: center;
      border: 1px solid #1d8d3b;
      cursor: pointer;
    }
  }

}
@media screen and (max-width:768px){
  .product_centers{
    min-width: unset!important;
    .in-banner{
      margin:0px auto auto auto!important;
    }
    .product_type_list{
      width: calc(100% - 20px);
    }
    .list-item{
      width: 100%!important;
      margin-left: 0!important;
      margin-top: 10px!important;
      float: unset!important;
      padding: 10px;
    }
    .sec_fadeInUp{
      min-width: unset!important;
      padding: 10px;
    }
    .pro_box{
      margin-left: 0!important;
    }

  }

}
</style>
